module.exports = __webpack_public_path__ + "static/media/boleto.f9709e24.svg";